export default "__VITE_ASSET__cdf39254__"